import React, { useContext, useMemo, useRef } from 'react';
import style from './Plan.module.scss';
import classnames from 'classnames';
import { getCostBlock } from '../Cost';
import { AppContext } from '../../context/AppContext';
import { seams } from '../../constants';
import { IOneTimePaymentItem } from '../../model';
import { preparePriceBlock } from '../Price';
import classNames from 'classnames';

export interface IProps {
  item: IOneTimePaymentItem;
}

const OneTimePurchaseItem = ({item}: IProps) => {
  const mainPlan = item;
  const contextData = useContext(AppContext)
  const {baseCheckoutPath} = contextData || {};

  const ref = useRef<HTMLDivElement>(null)

  const isSeams = useMemo(() => seams?.includes(String(mainPlan?.plan_id)), [mainPlan]);

  const wpBadge = useMemo(() => {
    // @ts-ignore
    return window.styles?.[mainPlan.plan_id];
  }, []);

  // const showWpBadge = Boolean(!currentBadge && wpBadge?.text);

  const bought = item.current?.active ?? item.current;

  return (
    <div className={style.plan_wrapper}>
      <div className={style.plan_space}/>
      <div
        className={classnames(
          style.plan,
          {[style.plan_current]: !!bought},
          {[style.seams]: isSeams},
          [style.yellow_one_time],
          wpBadge?.style ? {[style[wpBadge?.style]]: wpBadge?.style && wpBadge?.style !== 'default'} : {}
          // {[style.wp_badge]: showWpBadge}
        )}
        data-plan-id={item.plan_id}>
        {/*{showWpBadge ? <div className={style.wp_badge_item}>{wpBadge?.text}</div> : ""}*/}
        <div className={style.plan_top_part} ref={ref}>
          {!!bought ? <div className={classNames(style.current_plan_top, style.without_price)}>
            <h5>Your Purchase</h5>
          </div> : <></>}
          <h4 className={style.title}>
            {item.display.name}
          </h4>
          <div className={style.cost}>
            <div className={style.price}>{preparePriceBlock({
              amount: item.prices?.once.unit_amount
            })}</div>
          </div>
        </div>

        {!bought ? <div className={classnames(style.upgrade)}>
          <a
            href={`${baseCheckoutPath}?otp_ids=[${item.prices?.once.price_id}]`}
            className={classnames('button-primary button-primary_md upgrade-button', style.upgrade_button)}>
            Purchase
          </a>
        </div> : ''}
        <a className={style.more__info} href={'/almanac'} target="_blank" rel="noreferrer">
          More Info + Sample Chapter
        </a>
      </div>
      <div className={style.plan_space}/>
    </div>

  );
};

export default OneTimePurchaseItem;
